import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Button, Form, FormGroup, Label, Input, Row, Col } from "reactstrap";
import axios from "axios";


import Swal from "sweetalert2";

function TallasCreate() {
  const { user } = useContext(AuthContext);
  const URL_TALLAS = import.meta.env.VITE_URL_TALLAS;
  const URL_LOGS = import.meta.env.VITE_URL_LOGS;
  const [name, setName] = useState("");
  const [text, setText] = useState(false);
  const [validaBoton, setValidaBoton] = useState(true);
  const [nextOrder, setNextOrder] = useState(1);

  // Get the next order value when component loads
  useEffect(() => {
    getNextOrder();
  }, []);

  const getNextOrder = async () => {
    try {
      const response = await axios.get(URL_TALLAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      });
      
      const tallas = response.data;
      
      if (tallas.length === 0) {
        setNextOrder(1);
      } else {
        // Find the maximum order value and add 1
        const maxOrder = Math.max(
          ...tallas.map(talla => talla.order || 0)
        );
        setNextOrder(maxOrder + 1);
      }
    } catch (error) {
      console.log("Error getting next order:", error);
      // If there's an error, default to 1
      setNextOrder(1);
    }
  };

  const clear = () => {
    setName("");
    // Refresh the next order value after clearing
    getNextOrder();
  };

  const saveTallas = (event) => {
    event.preventDefault();
    setValidaBoton(false);
    
    axios
      .post(
        URL_TALLAS,
        {
          name,
          order: nextOrder, // Include the order field
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Crear Talla",
            detalle: `${name} - Orden: ${nextOrder}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        clear();
        Swal.fire("Good job!", "Creado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        setValidaBoton(true); // Re-enable button on error
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
        });
        console.log(error);
      });
  };

  return (
    <>
      <div className="container">
        <h3 align="center">Crea una Talla</h3>
        <Form onSubmit={saveTallas}>
          <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
            <Label for="exampleEmail" className="mr-sm-2">
              Talla
            </Label>
            <Input
              type="text"
              name="email"
              id="exampleEmail"
              placeholder="Nombre de la Talla"
              value={name}
              required
              onChange={(e) => {
                setName(e.target.value);
              }}
            />
          </FormGroup>
          
          {/* Optional: Show the order that will be assigned */}
          <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
            <small className="text-muted">
              <i className="fas fa-info-circle"></i> Se asignará el orden: <strong>{nextOrder}</strong>
            </small>
          </FormGroup>

          <Row className="container">
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardando...
              </Button>
            )}
            <Button color="danger" href="/MenuArticulos">
              Regresar
            </Button>
          </Row>
        </Form>
      </div>
    </>
  );
}

export default TallasCreate;